
import {
  FullWireDef,
  Question,
  Wire,
  WireDef,
} from "../Types";

const Note = {
  error: (..._: any[]) => {},
}

export type WireLike = {
  concept: string;
  from: string;
  to: string;
};

export const wireToString = (wire: WireLike): string => {
  return `${wire.concept}:${wire.from}>${wire.to}`;
};

// abc:a>b to {concept: 'abc', from: 'a', to: 'b'}
export const stringToWire = (str: string): WireLike[] => {
  const [concept, fromTo] = str.split(":");
  if (!concept || !fromTo) {
    Note.error("core", "invalid wire string:", str || "<empty>");
    return [];
  }
  let [from, to] = fromTo.split("<>");
  if (to) {
    return [{ concept, from, to }, {
      concept,
      from: to,
      to: from,
    }];
  }
  [from, to] = fromTo.split(">");

  if (to) {
    return [{ concept, from, to }];
  }

  Note.error("core", "Could not parse wire from string:", str);
  return [];
};

export const partialStringToWire = (str: string): WireDef[] => {
  let [from, to] = str.split("<>");
  if (to) {
    return [{ from, to }, { from: to, to: from }];
  }

  [from, to] = from.split(">");
  if (to) {
    return [{ from, to }];
  }

  Note.error("core", "Could not parse wire from string:", str);
  return [];
};